import {Directive, Input, NgModule, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {AuthService} from 'app/core/security/auth.service';
import {CommonModule} from '@angular/common';
import {CoreModule} from '../core/core.module';

@Directive({
    selector: '[fxs]'
})
export class FxDirective implements OnInit {


    private hasView = false;

    constructor(private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef,
                private authService: AuthService) { }

    ngOnInit(): void {
    }

    @Input() set fxs(fxs: string[]) {
        this.authService.user
            .filter(user => !!user)
            .map(user => user.fxs.map(fx => fx.fxname))
            .map(ufxs => fxs.every(fx => ufxs.some(f => f == fx)))
            .subscribe(b => {
                if(b && !this.hasView) {
                    this.viewContainer.createEmbeddedView(this.templateRef);
                    this.hasView = true;
                }else if(!b && this.hasView){
                    this.viewContainer.clear();
                    this.hasView = false;
                }
            });
    }

}

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
    ],
    exports: [FxDirective],
    declarations: [FxDirective]

})
export class FXDirectiveModule {
}



// WEBPACK FOOTER //
// ./src/app/directives/fx.directive.ts